import React, { Fragment } from 'react'
import styled from '@emotion/styled'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import MailchimpSubscribe from 'react-mailchimp-subscribe'

import theme from '../styles/theme'
import { media, rem } from '../styles/tools'

import Space from '../components/Space'
import { WideText } from '../styles/typography'

const Field = styled.div({
  flex: 1,
  position: 'relative',
  '::after': {
    content: '"*"',
    position: 'absolute',
    top: 0,
    right: 0,
    fontSize: 22,
    color: '#f44336',
  },
})

const Input = styled.input(({ isTouched, isInvalid }) => ({
  width: '100%',
  padding: 0,
  paddingRight: 12, // space for Field's asterisk
  fontWeight: 700,
  fontSize: rem(18),
  [media.laptop]: { fontSize: '1.45vw' },
  lineHeight: 1.6,
  fontFamily: 'inherit',
  color: isInvalid
    ? '#f44336'
    : isTouched
    ? 'currentColor'
    : theme.colors.grey_400,
  backgroundColor: 'transparent',
  outline: 'none',
  border: 'none',
  borderRadius: 0,
  borderBottom: '1px solid',
  borderColor: isInvalid && '#f44336',
  transition: '.3s',
  '::placeholder': { color: isInvalid ? '#f44336' : theme.colors.grey_400 },
  ':focus': { color: 'currentColor' },
}))

const NewsletterForm = ({
  defaultMessage,
  successMessage,
  errorMessage,
  ...props
}) => (
  <MailchimpSubscribe
    url="https://design.us18.list-manage.com/subscribe/post?u=47ac7c370c3a2b56244dac91f&id=f1a2a12baa"
    render={({ subscribe, status, message }) => (
      <Formik
        initialValues={{ fullname: '', email: '' }}
        validationSchema={Yup.object().shape({
          email: Yup.string()
            .email()
            .required(),
          fullname: Yup.string().required(),
        })}
        onSubmit={formData => {
          const fullname = /(.+?)\s(.+)/.exec(formData.fullname)

          const data = {
            FNAME: fullname ? fullname[1] : formData.fullname,
            LNAME: fullname ? fullname[2] : '',
            EMAIL: formData.email,
          }
          subscribe(data)
        }}
      >
        {({
          values,
          errors,
          touched,
          isSubmitting,
          handleChange,
          handleBlur,
        }) => (
          <Form>
            {status === 'success' ? (
              successMessage(message)
            ) : status === 'error' ? (
              errorMessage(message)
            ) : (
              <Fragment>
                {defaultMessage(message)}
                <div
                  css={{
                    [media.tablet]: { display: 'flex', alignItems: 'center' },
                  }}
                >
                  <Field>
                    <Input
                      placeholder="Full Name"
                      isTouched={touched.fullname}
                      isInvalid={touched.fullname && errors.fullname}
                      name="fullname"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.fullname}
                    />
                  </Field>
                  <Space xy={20} />
                  <Field>
                    <Input
                      placeholder="Email Address"
                      isTouched={touched.email}
                      isInvalid={touched.email && errors.email}
                      name="email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                    />
                  </Field>
                  <Space xy={20} />
                  <WideText as="button" type="submit" disabled={isSubmitting}>
                    Subscribe
                  </WideText>
                </div>
              </Fragment>
            )}
          </Form>
        )}
      </Formik>
    )}
  />
)

export default NewsletterForm
